import 'twin.macro'

import { Collapse } from 'react-collapse'
import { useTranslation } from 'react-i18next'

const LeadConditions = ({ isOpened = true, variant }: { isOpened: boolean; variant: string }) => {
  return <Collapse isOpened={isOpened}>{variant === '1' ? <USAParams /> : <BeneficialOwner />}</Collapse>
}

const USAParams = () => {
  const { t } = useTranslation()
  return (
    <ul tw='ml-12 list-disc text-sm mt-4'>
      <li>{t('flow-agreement-usa-taxes')}</li>
      <li>{t('flow-agreement-usa-state')}</li>
      <li>{t('flow-agreement-usa-born')}</li>
      <li>{t('flow-agreement-usa-post')}</li>
      <li>{t('flow-agreement-usa-phone')}</li>
      <li>{t('flow-agreement-usa-deals')}</li>
      <li>{t('flow-agreement-usa-month')}</li>
      <li>{t('flow-agreement-usa-last-three-years')}</li>
    </ul>
  )
}

const BeneficialOwner = () => {
  const { t } = useTranslation()
  return (
    <ul tw='ml-12 list-disc text-sm mt-4'>
      <li>{t('flow-agreement-not-physic')}</li>
    </ul>
  )
}

export default LeadConditions
